export enum EInput {
  TEXT = 'text',
  NUMBER = 'number',
  DECIMAL = 'decimal',
  EMAIL = 'email',
  PASSWORD = 'password',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  SELECT = 'select',
}

export type TInput =
  | EInput.TEXT
  | EInput.NUMBER
  | EInput.DECIMAL
  | EInput.EMAIL
  | EInput.PASSWORD
  | EInput.CHECKBOX
  | EInput.RADIO
  | EInput.SELECT;

export enum ERadio {
  YES = 'yes',
  NO = 'no',
}
